(() => {
  'use strict';

  if (customElements.get('salabom-menopause-quiz')) return;

  const agreementAnswers = (profile) => [
    { label: 'Súhlasím', scores: { [profile]: 1 }, tag: 'agree' },
    { label: 'Neutrálne / neviem posúdiť', scores: {}, tag: 'neutral' },
    { label: 'Nesúhlasím', scores: {}, tag: 'disagree' }
  ];

  const QUESTIONS = [
    {
      id: 'hot-flushes',
      text: 'V posledných mesiacoch mávam náhle návaly tepla, začervenanie alebo potenie.',
      answers: agreementAnswers('temperature')
    },
    {
      id: 'night-sweats',
      text: 'Budím sa v noci spotená alebo mi býva v posteli náhle príliš teplo.',
      answers: agreementAnswers('temperature')
    },
    {
      id: 'heat-disruption',
      text: 'Pocity tepla alebo potenie mi narúšajú prácu, oddych či spoločenské situácie.',
      answers: agreementAnswers('temperature')
    },
    {
      id: 'falling-asleep',
      text: 'Aj keď som unavená, zaspávanie mi trvá dlhšie než kedysi.',
      answers: agreementAnswers('sleep')
    },
    {
      id: 'broken-sleep',
      text: 'Počas noci sa opakovane budím a ťažko znovu zaspávam.',
      answers: agreementAnswers('sleep')
    },
    {
      id: 'daytime-fatigue',
      text: 'Cez deň mávam menej energie alebo sa budím bez pocitu oddýchnutia.',
      answers: agreementAnswers('sleep')
    },
    {
      id: 'mood-changes',
      text: 'V posledných mesiacoch u seba častejšie vnímam podráždenosť, úzkosť alebo pokles nálady.',
      answers: agreementAnswers('mind')
    },
    {
      id: 'concentration',
      text: 'Ťažšie sa sústredím alebo mám pocit „mozgovej hmly“.',
      answers: agreementAnswers('mind')
    },
    {
      id: 'forgetfulness',
      text: 'Častejšie zabúdam slová, mená, termíny alebo bežné povinnosti.',
      answers: agreementAnswers('mind')
    },
    {
      id: 'vaginal-dryness',
      text: 'Pociťujem vaginálnu suchosť, pálenie alebo nepríjemné pocity v intímnej oblasti.',
      answers: agreementAnswers('intimate')
    },
    {
      id: 'sexual-discomfort',
      text: 'Pri sexuálnej aktivite mávam nepohodlie alebo bolesť, prípadne sa znížila moja chuť na sex.',
      answers: agreementAnswers('intimate')
    },
    {
      id: 'urinary-changes',
      text: 'Častejšie pociťujem nutkanie na močenie, únik moču alebo opakované močové ťažkosti.',
      answers: agreementAnswers('intimate')
    },
    {
      id: 'joint-pain',
      text: 'Častejšie ma bolia alebo tuhnú kĺby a svaly bez zjavnej inej príčiny.',
      answers: agreementAnswers('body')
    },
    {
      id: 'headaches',
      text: 'V posledných mesiacoch sa objavili alebo zhoršili bolesti hlavy či migrény.',
      answers: agreementAnswers('body')
    },
    {
      id: 'physical-comfort',
      text: 'Telesné zmeny alebo nepohodlie citeľne ovplyvňujú môj pohyb a každodenné fungovanie.',
      answers: agreementAnswers('body')
    },
    {
      id: 'age-range',
      text: 'Do ktorej vekovej skupiny patríš?',
      hint: 'Táto odpoveď neovplyvňuje výsledný menopauzálny profil.',
      answers: [
        { label: 'Menej ako 40 rokov', scores: {}, tag: 'under-40' },
        { label: '40 – 44 rokov', scores: {}, tag: '40-44' },
        { label: '45 – 54 rokov', scores: {}, tag: '45-54' },
        { label: '55 – 64 rokov', scores: {}, tag: '55-64' },
        { label: '65 rokov a viac', scores: {}, tag: '65-plus' }
      ]
    }
  ];

  const RESULTS = {
    temperature: {
      tag: 'quiz-menopause-profile-temperature',
      title: 'Profil termoregulácie',
      summary: 'V tvojich odpovediach dominujú návaly tepla a nočné potenie. Tieto prejavy patria medzi časté symptómy menopauzálneho prechodu a môžu ovplyvniť spánok, energiu aj sebavedomie. Nemusíš ich jednoducho pretrpieť – existujú praktické kroky aj možnosti liečby.',
      advice: {
        relief: [
          'Nos ľahké vrstvy, maj poruke vodu alebo ventilátor a spálňu udržuj skôr chladnú.',
          'Dva až tri týždne si zapisuj, kedy sa návaly objavia. Medzi individuálne spúšťače môžu patriť alkohol, kofeín, horúce nápoje, pikantné jedlá, fajčenie alebo stres.',
          'Pri návale skús pokojný, pomalší dych a presuň sa do chladnejšieho prostredia. Cieľom je zmierniť nepohodlie, nie „zastaviť“ telo silou.'
        ],
        wellbeing: [
          'Pravidelný pohyb podporuje celkové zdravie; vyber si čas a intenzitu, pri ktorých sa neprehrievaš.',
          'Dbaj na pravidelný spánkový režim a ľahšiu posteľnú bielizeň, najmä ak ťa budí nočné potenie.',
          'Nefajči a alkohol obmedz podľa vlastných spúšťačov – oba môžu symptómy zhoršovať.'
        ],
        support: [
          'Ak návaly narúšajú spánok alebo bežný život, porozprávaj sa s gynekológom či všeobecným lekárom o hormonálnych aj nehormonálnych možnostiach.',
          'Kognitívno-behaviorálna terapia môže pomôcť zvládať návaly, spánok aj stres spojený so symptómami.',
          'Nové búšenie srdca, bolesť na hrudi, dýchavicu alebo mdlobu nepripisuj automaticky menopauze a vyhľadaj lekársku pomoc.'
        ]
      }
    },
    sleep: {
      tag: 'quiz-menopause-profile-sleep',
      title: 'Spánkový a energetický profil',
      summary: 'Najvýraznejšie sa u teba ukazuje narušený spánok a únava. Hormonálne zmeny, nočné potenie aj stres sa môžu navzájom zosilňovať. Zmyslom nie je podať cez deň ešte väčší výkon, ale postupne obnoviť podmienky pre kvalitnejší odpočinok.',
      advice: {
        relief: [
          'Vstávaj približne v rovnakom čase aj po horšej noci a vytvor si krátky, opakovateľný večerný rituál.',
          'Spálňu udržuj tmavú, tichú a chladnejšiu. Ak ťa budí potenie, priprav si ľahkú náhradnú vrstvu oblečenia.',
          'Kofeín skús presunúť do prvej časti dňa a večer obmedz alkohol, ktorý síce môže urýchliť zaspávanie, ale narúša kvalitu spánku.'
        ],
        wellbeing: [
          'Pravidelný denný pohyb a pobyt na dennom svetle podporujú rytmus spánku. Náročný tréning tesne pred spaním nemusí vyhovovať každému.',
          'Jedz pravidelne a pestro; únavu nerieš iba kávou. Dlhodobú alebo výraznú únavu je vhodné vyšetriť.',
          'V deň po zlej noci zníž nároky a uprednostni krátku prechádzku či mobilitu pred režimom „všetko alebo nič“.'
        ],
        support: [
          'Ak nespavosť trvá, výrazne obmedzuje fungovanie alebo hlasno chrápeš s pauzami v dýchaní, obráť sa na lekára.',
          'Kognitívno-behaviorálna terapia patrí medzi možnosti pomoci pri problémoch so spánkom a náladou.',
          'S blízkymi si rozdeľ ranné či večerné povinnosti a pomenuj únavu konkrétne, aby podpora neostala iba pri všeobecnom „oddýchni si“. '
        ]
      }
    },
    mind: {
      tag: 'quiz-menopause-profile-mind',
      title: 'Náladový a kognitívny profil',
      summary: 'Tvoje odpovede smerujú najmä k zmenám nálady, úzkosti, zabúdaniu alebo „mozgovej hmle“. Tieto ťažkosti sú reálne a môžu sa počas menopauzálneho prechodu objaviť, no nie každá psychická či kognitívna zmena musí byť spôsobená menopauzou.',
      advice: {
        relief: [
          'Zníž počet rozhodnutí: používaj krátke zoznamy, pripomienky a dokončuj jednu úlohu naraz.',
          'Pri napätí skús krátku prechádzku, pomalé dýchanie alebo inú relaxačnú aktivitu, ktorú vieš opakovať pravidelne.',
          'Sleduj súvislosti medzi náladou, spánkom, alkoholom, kofeínom a návalmi; záznam ti pomôže pomenovať vzorec lekárovi.'
        ],
        wellbeing: [
          'Pravidelný pohyb, odpočinok a kontakt s ľuďmi, pri ktorých sa cítiš bezpečne, podporujú psychickú pohodu.',
          'Jedz pravidelne a vyhni sa prísnym diétam sľubujúcim „hormonálny reset“. Menopauzu nemožno vyriešiť jednou potravinou.',
          'Chráň si bloky sústredenia bez notifikácií a medzi nimi si daj krátku pohybovú pauzu.'
        ],
        support: [
          'Ak zmeny nálady, úzkosť alebo pamäť ovplyvňujú bežný život, preber ich s lekárom; existujú psychologické aj medicínske možnosti pomoci.',
          'Pri myšlienkach na sebapoškodenie alebo samovraždu vyhľadaj okamžitú krízovú pomoc alebo volaj 112.',
          'Povedz blízkym konkrétne, čo potrebuješ – napríklad jednu požiadavku naraz, písomné zhrnutie alebo krátku pauzu.'
        ]
      }
    },
    intimate: {
      tag: 'quiz-menopause-profile-intimate',
      title: 'Intímny a urogenitálny profil',
      summary: 'U teba vystupujú do popredia zmeny v intímnej oblasti – suchosť, nepohodlie, zmeny túžby alebo močové ťažkosti. Sú časté, ale nemusia zostať nevypovedané. Citlivá, konkrétna konzultácia môže priniesť výraznú úľavu.',
      advice: {
        relief: [
          'Na suchosť môže pomôcť vaginálny hydratačný prípravok; pri sexuálnej aktivite vyskúšaj lubrikant na vodnej alebo silikónovej báze.',
          'Ak používaš latexové kondómy, nepoužívaj s nimi olejový lubrikant, pretože môže latex poškodiť.',
          'Pri intimite spomaľ, dopraj si viac času a bez výčitiek zastav činnosť, ktorá bolí. Bolesť nie je povinná súčasť menopauzy.'
        ],
        wellbeing: [
          'Hydratácia a jemná hygiena bez parfumovaných prípravkov môžu znížiť ďalšie dráždenie intímnej oblasti.',
          'Pravidelný pohyb a tréning panvového dna môžu podporiť celkové aj panvové zdravie; pri bolesti je vhodné odborné vedenie.',
          'Otvorená komunikácia o pohodlí, túžbe a hraniciach je súčasťou starostlivosti, nie zlyhaním vzťahu.'
        ],
        support: [
          'Gynekológ alebo lekár môže posúdiť príčinu a prebrať lokálnu hormonálnu aj nehormonálnu liečbu.',
          'Pálenie pri močení, krv v moči, horúčka alebo opakované infekcie potrebujú vyšetrenie a nemajú sa automaticky pripísať menopauze.',
          'Akékoľvek krvácanie po 12 mesiacoch bez menštruácie konzultuj s lekárom čo najskôr.'
        ]
      }
    },
    body: {
      tag: 'quiz-menopause-profile-body',
      title: 'Telesný a pohybový profil',
      summary: 'Najviac u teba vystupujú bolesti, stuhnutosť a telesné nepohodlie. Menopauzálny prechod môže ovplyvniť svaly, kĺby aj vnímanie vlastného tela, no nové alebo výrazné bolesti treba posudzovať individuálne a nehádzať automaticky na hormóny.',
      advice: {
        relief: [
          'Pri stuhnutí začni jemnou mobilitou alebo krátkou chôdzou a záťaž zvyšuj postupne podľa toho, ako sa cítiš.',
          'Striedaj polohy pri práci a naplánuj si krátke pohybové prestávky skôr, než nepohodlie zosilnie.',
          'Zapisuj si miesto, trvanie a intenzitu bolesti aj to, čo ju zlepšuje alebo zhoršuje; pomôže to pri konzultácii.'
        ],
        wellbeing: [
          'Kombinuj pravidelný silový tréning s aktivitami, pri ktorých nesieš vlastnú hmotnosť, napríklad chôdzou či tancom; podporuješ tým svaly aj kosti.',
          'Jedz pestro a zaraď zdroje vápnika. O vhodnosti vitamínu D alebo iných doplnkov sa poraď s lekárom či lekárnikom.',
          'Regenerácia je súčasť plánu. Pohyb nemá zvyšovať ostrú bolesť, závrat ani nevoľnosť.'
        ],
        support: [
          'Novú, silnú alebo jednostrannú bolesť, opuch kĺbu či neurologické príznaky konzultuj s lekárom.',
          'Preber s lekárom zdravie kostí a svoje rizikové faktory, najmä pri skorej menopauze, zlomeninách alebo osteoporóze v rodine.',
          'Požiadaj fyzioterapeuta alebo trénera so zdravotným vzdelaním o bezpečnú progresiu, ak si dlho necvičila alebo ťa pohyb bolí.'
        ]
      }
    },
    combined: {
      tag: 'quiz-menopause-profile-combined',
      title: 'Kombinovaný menopauzálny profil',
      summary: 'Tvoje odpovede nevytvorili jeden dominantný vzorec. Symptómy menopauzálneho prechodu sa často prelínajú a v čase menia; prípadne si označila len málo výrazných ťažkostí. Začni tým, čo má dnes najväčší vplyv na tvoju pohodu, a zmeny sleduj bez tlaku vyriešiť všetko naraz.',
      advice: {
        relief: [
          'Dva až štyri týždne si stručne zapisuj symptómy, spánok a možné spúšťače. Vyber potom jednu zmenu, ktorú vieš reálne udržať.',
          'Pri návaloch pomôže vrstvenie oblečenia a chladnejšie prostredie; pri intímnej suchosti hydratačný prípravok alebo vhodný lubrikant.',
          'Zjednoduš si náročnejšie dni a konkrétne pomenuj blízkym, s čím potrebuješ pomôcť.'
        ],
        wellbeing: [
          'Podpor pravidelný spánok, pestrú stravu a pohyb, ktorý zahŕňa vytrvalosť, silu aj aktivity s vlastnou hmotnosťou.',
          'Nefajči a alkohol drž v odporúčaných medziach; sleduj, či alkohol alebo kofeín nezhoršujú tvoje konkrétne symptómy.',
          'Pred užívaním bylinných alebo „hormonálnych“ doplnkov sa poraď s lekárom či lekárnikom, najmä ak užívaš lieky.'
        ],
        support: [
          'Ak symptómy ovplyvňujú zdravie, prácu, vzťahy alebo spánok, preber s lekárom možnosti liečby podľa svojej anamnézy a preferencií.',
          'Ak máš menej ako 45 rokov a podozrenie na menopauzálny prechod, objednaj sa na odbornú konzultáciu.',
          'Akékoľvek krvácanie po 12 mesiacoch bez menštruácie, závažné psychické ťažkosti alebo náhle nezvyčajné príznaky rieš s lekárom bez odkladu.'
        ]
      }
    }
  };

  const PROFILE_ORDER = ['temperature', 'sleep', 'mind', 'intimate', 'body'];

  class SalabomMenopauseQuiz extends HTMLElement {
    constructor() {
      super();
      this.state = {
        screen: 'intro',
        questionIndex: 0,
        answers: new Array(QUESTIONS.length).fill(null),
        profile: null,
        leadTracked: false,
        submitting: false
      };
      this.config = {};
      this.abortController = null;
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.abortController = new AbortController();
      this.cacheElements();

      try {
        const configNode = this.querySelector('[data-quiz-config]');
        this.config = configNode ? JSON.parse(configNode.textContent) : {};
      } catch (error) {
        console.error('Salabom menopause quiz: konfiguráciu sa nepodarilo načítať.', error);
        this.config = { sectionId: this.dataset.sectionId || this.id };
      }

      const restoredAfterSignup = this.restoreResultFromUrl();
      this.bindEvents();
      this.enableForm();
      this.render();
      if (restoredAfterSignup) {
        this.track('quiz_completed', {
          quiz_profile: this.state.profile,
          marketing_consent: true,
          stored_in_shopify: true
        });
        this.focusHeading();
      }
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
      this.dataset.initialized = 'false';
    }

    cacheElements() {
      this.elements = {
        intro: this.querySelector('[data-screen="intro"]'),
        question: this.querySelector('[data-screen="question"]'),
        email: this.querySelector('[data-screen="email"]'),
        result: this.querySelector('[data-screen="result"]'),
        fatal: this.querySelector('[data-screen="fatal"]'),
        questionCount: this.querySelector('[data-question-count]'),
        progressWrap: this.querySelector('[data-progress-wrap]'),
        progress: this.querySelector('[data-progress]'),
        progressText: this.querySelector('[data-progress-text]'),
        questionTitle: this.querySelector('[data-question-title]'),
        selectionInstruction: this.querySelector('[data-selection-instruction]'),
        questionHint: this.querySelector('[data-question-hint]'),
        answers: this.querySelector('[data-answers]'),
        back: this.querySelector('[data-back]'),
        next: this.querySelector('[data-next]'),
        form: this.querySelector('.salabom-quiz__email-form'),
        emailInput: this.querySelector('[data-email-input]'),
        consent: this.querySelector('[data-marketing-consent]'),
        tags: this.querySelector('[data-customer-tags]'),
        formStatus: this.querySelector('[data-form-status]'),
        previewProfileName: this.querySelector('[data-preview-profile-name]'),
        profileName: this.querySelector('[data-profile-name]'),
        profileSummary: this.querySelector('[data-profile-summary]'),
        tips: this.querySelector('[data-profile-tips]'),
        product: this.querySelector('[data-product]'),
        productImage: this.querySelector('[data-product-image]'),
        productPlaceholder: this.querySelector('[data-product-placeholder]'),
        productName: this.querySelector('[data-product-name]'),
        productPrice: this.querySelector('[data-product-price]'),
        productLink: this.querySelector('[data-product-link]'),
        addToCart: this.querySelector('[data-add-to-cart]'),
        resultLive: this.querySelector('[data-result-live]')
      };
    }

    bindEvents() {
      const signal = this.abortController.signal;
      this.querySelector('[data-start]')?.addEventListener('click', () => this.start(), { signal });
      this.elements.back?.addEventListener('click', () => this.goBack(), { signal });
      this.elements.next?.addEventListener('click', () => this.goNext(), { signal });
      this.elements.answers?.addEventListener('change', (event) => this.selectAnswer(event), { signal });
      this.elements.consent?.addEventListener('change', () => {
        this.setFormStatus('', false);
        this.updateSubmitAvailability();
      }, { signal });
      this.elements.form?.addEventListener('submit', (event) => this.handleEmailSubmit(event), { signal, capture: true });
      this.elements.productLink?.addEventListener('click', () => this.trackProductClick(), { signal });
      this.elements.addToCart?.addEventListener('click', () => this.addToCart(), { signal });
      this.querySelector('[data-restart]')?.addEventListener('click', () => this.restart(), { signal });
    }

    enableForm() {
      if (this.elements.questionCount) this.elements.questionCount.textContent = String(QUESTIONS.length);
      if (this.elements.emailInput) this.elements.emailInput.disabled = false;
      this.updateSubmitAvailability();
    }

    updateSubmitAvailability() {
      const submit = this.elements.form?.querySelector('[type="submit"]');
      if (submit) submit.disabled = this.state.submitting || !this.elements.consent?.checked;
    }

    start() {
      this.state.screen = 'question';
      this.track('quiz_started');
      this.render();
      this.focusHeading();
    }

    selectAnswer(event) {
      const input = event.target.closest('input[data-answer-index]');
      if (!input) return;
      const answerIndex = Number(input.dataset.answerIndex);
      if (!Number.isInteger(answerIndex)) return;
      const question = QUESTIONS[this.state.questionIndex];

      if (question.multiple) {
        const noneIndex = question.answers.findIndex((answer) => Object.keys(answer.scores).length === 0);
        let selected = Array.isArray(this.state.answers[this.state.questionIndex])
          ? [...this.state.answers[this.state.questionIndex]]
          : [];

        if (input.checked) {
          selected = answerIndex === noneIndex
            ? [answerIndex]
            : [...selected.filter((index) => index !== noneIndex), answerIndex];
        } else {
          selected = selected.filter((index) => index !== answerIndex);
        }
        this.state.answers[this.state.questionIndex] = [...new Set(selected)].sort((a, b) => a - b);
      } else {
        this.state.answers[this.state.questionIndex] = answerIndex;
      }

      this.elements.next.disabled = !this.hasAnswer(this.state.answers[this.state.questionIndex]);
      this.updateSelectedCards();
    }

    goNext() {
      const selection = this.state.answers[this.state.questionIndex];
      if (!this.hasAnswer(selection)) return;
      const question = QUESTIONS[this.state.questionIndex];
      const answerIndexes = Array.isArray(selection) ? selection : [selection];
      this.track('quiz_question_answered', {
        question_number: this.state.questionIndex + 1,
        question_id: question.id,
        answer: answerIndexes.map((index) => question.answers[index]?.label).filter(Boolean).join(' | '),
        multiple_choice: Boolean(question.multiple)
      });

      if (this.state.questionIndex < QUESTIONS.length - 1) {
        this.state.questionIndex += 1;
        this.renderQuestion();
        this.focusHeading();
      } else {
        this.state.profile = this.calculateProfile();
        this.state.screen = 'email';
        this.render();
        this.focusHeading();
      }
    }

    goBack() {
      if (this.state.questionIndex === 0) {
        this.state.screen = 'intro';
        this.render();
        this.focusHeading();
        return;
      }
      this.state.questionIndex -= 1;
      this.renderQuestion();
      this.focusHeading();
    }

    calculateProfile() {
      const totals = { temperature: 0, sleep: 0, mind: 0, intimate: 0, body: 0 };
      QUESTIONS.forEach((question, index) => {
        const selection = this.state.answers[index];
        const answerIndexes = Array.isArray(selection) ? selection : [selection];
        answerIndexes.forEach((answerIndex) => {
          const answer = question.answers[answerIndex];
          if (!answer) return;
          Object.entries(answer.scores).forEach(([key, value]) => {
            if (Object.prototype.hasOwnProperty.call(totals, key)) totals[key] += value;
          });
        });
      });

      const ranked = PROFILE_ORDER
        .map((key) => ({ key, score: totals[key] }))
        .sort((a, b) => b.score - a.score || PROFILE_ORDER.indexOf(a.key) - PROFILE_ORDER.indexOf(b.key));

      const topScore = ranked[0].score;
      const tied = ranked.filter((item) => item.score === topScore);

      if (topScore <= 1) return 'combined';
      if (tied.length === 1) return ranked[0].key;
      return 'combined';
    }

    handleEmailSubmit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (this.state.submitting) return;

      if (!this.elements.emailInput?.checkValidity()) {
        this.elements.emailInput?.reportValidity();
        return;
      }

      if (!this.elements.consent?.checked) {
        this.setFormStatus('Pre zobrazenie odporúčaní je potrebné zaškrtnúť marketingový súhlas.', true);
        this.updateSubmitAvailability();
        return;
      }

      this.track('quiz_email_submitted', {
        quiz_profile: this.state.profile,
        marketing_consent: true
      });
      this.trackLead();

      const result = RESULTS[this.state.profile] || RESULTS.combined;
      if (this.elements.tags) {
        this.elements.tags.value = ['newsletter', 'quiz-menopause', result.tag, ...this.getAnswerTags()].join(',');
      }
      const returnTo = this.elements.form?.elements?.return_to;
      if (returnTo) {
        const returnUrl = new URL(returnTo.value, window.location.origin);
        returnUrl.searchParams.set('quiz_result', this.state.profile || 'combined');
        returnTo.value = `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`;
      }
      const submitButton = this.elements.form?.querySelector('[type="submit"]');
      const originalButtonText = submitButton?.innerHTML || '';
      this.state.submitting = true;
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Načítavam odporúčania...';
      }
      this.setFormStatus('', false);

      try {
        this.submitMarketingForm();
      } catch (error) {
        console.error('Salabom menopause quiz: e-mail sa nepodarilo uložiť do Shopify.', error);
        this.setFormStatus('E-mail sa nepodarilo uložiť. Skús to, prosím, ešte raz.', true);
        this.state.submitting = false;
        if (submitButton) {
          submitButton.innerHTML = originalButtonText;
        }
        this.updateSubmitAvailability();
      }
    }

    submitMarketingForm() {
      const form = this.elements.form;
      if (!form?.action) throw new Error('Customer form nemá cieľovú URL.');

      const captcha = window.Shopify?.captcha;
      if (typeof captcha?.protect !== 'function') throw new Error('Shopify CAPTCHA nie je dostupná.');
      captcha.protect(form, () => form.submit());
    }

    getAnswerTags() {
      return QUESTIONS.flatMap((question, index) => {
        const selection = this.state.answers[index];
        const answerIndexes = Array.isArray(selection) ? selection : [selection];
        return answerIndexes.map((answerIndex) => {
          const answer = question.answers[answerIndex];
          if (!answer) return null;
          const answerCode = answer.tag || Object.keys(answer.scores)[0] || 'none';
          return `quiz-menopause-answer-${question.id}-${answerCode}`;
        });
      }).filter(Boolean);
    }

    restoreResultFromUrl() {
      const url = new URL(window.location.href);
      const profile = url.searchParams.get('quiz_result');
      const wasSaved = url.searchParams.get('quiz_email_saved') === '1';
      if (!wasSaved || !RESULTS[profile]) return false;

      this.state.profile = profile;
      this.state.screen = 'result';
      this.state.leadTracked = true;
      url.searchParams.delete('quiz_email_saved');
      url.searchParams.delete('quiz_result');
      window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
      return true;
    }

    restart() {
      this.state = {
        screen: 'intro',
        questionIndex: 0,
        answers: new Array(QUESTIONS.length).fill(null),
        profile: null,
        leadTracked: false,
        submitting: false
      };
      if (this.elements.form) this.elements.form.reset();
      this.updateSubmitAvailability();
      this.setFormStatus('', false);
      this.render();
      this.focusHeading();
    }

    render() {
      ['intro', 'question', 'email', 'result', 'fatal'].forEach((name) => {
        const element = this.elements?.[name];
        if (element) element.hidden = name !== this.state.screen;
      });
      if (this.state.screen === 'question') this.renderQuestion();
      if (this.state.screen === 'email') this.renderEmail();
      if (this.state.screen === 'result') this.renderResult();
    }

    renderEmail() {
      const profileKey = RESULTS[this.state.profile] ? this.state.profile : 'combined';
      if (this.elements.previewProfileName) {
        this.elements.previewProfileName.textContent = RESULTS[profileKey].title;
      }
    }

    renderQuestion() {
      const question = QUESTIONS[this.state.questionIndex];
      if (!question || !this.elements.answers) return;

      this.elements.questionTitle.textContent = question.text;
      this.elements.selectionInstruction.textContent = question.multiple
        ? 'Viac možností · vyber všetky, ktoré platia'
        : question.id === 'age-range'
          ? 'Jedna možnosť · vyber svoju vekovú skupinu'
          : 'Jedna možnosť · označ mieru súhlasu';
      this.elements.selectionInstruction.classList.toggle('is-multiple', Boolean(question.multiple));
      this.elements.questionHint.textContent = question.hint || '';
      this.elements.questionHint.hidden = !question.hint;
      const progressStep = this.state.questionIndex + 1;
      this.elements.progressText.textContent = `Otázka ${progressStep} zo ${QUESTIONS.length}`;
      this.elements.progress.value = progressStep;
      this.elements.progress.max = QUESTIONS.length;
      this.elements.progress.setAttribute('value', String(progressStep));
      this.elements.progress.setAttribute('max', String(QUESTIONS.length));
      this.elements.progress.textContent = `${progressStep} zo ${QUESTIONS.length}`;
      this.elements.progress.setAttribute('aria-valuenow', String(progressStep));
      this.elements.progress.setAttribute('aria-valuemax', String(QUESTIONS.length));
      this.elements.answers.replaceChildren();

      const selection = this.state.answers[this.state.questionIndex];
      const selectedIndexes = Array.isArray(selection) ? selection : [selection];
      question.answers.forEach((answer, answerIndex) => {
        const label = document.createElement('label');
        label.className = 'salabom-quiz__answer';
        if (selectedIndexes.includes(answerIndex)) label.classList.add('is-selected');

        const input = document.createElement('input');
        input.type = question.multiple ? 'checkbox' : 'radio';
        input.name = `salabom-answer-${this.config.sectionId}-${this.state.questionIndex}`;
        input.value = String(answerIndex);
        input.dataset.answerIndex = String(answerIndex);
        input.checked = selectedIndexes.includes(answerIndex);

        const marker = document.createElement('span');
        marker.className = 'salabom-quiz__answer-marker';
        marker.setAttribute('aria-hidden', 'true');

        const text = document.createElement('span');
        text.className = 'salabom-quiz__answer-text';
        text.textContent = answer.label;

        label.append(input, marker, text);
        this.elements.answers.append(label);
      });

      this.elements.answers.setAttribute('role', question.multiple ? 'group' : 'radiogroup');
      this.elements.next.disabled = !this.hasAnswer(selection);
    }

    hasAnswer(selection) {
      return Array.isArray(selection) ? selection.length > 0 : Number.isInteger(selection);
    }

    updateSelectedCards() {
      const selection = this.state.answers[this.state.questionIndex];
      const selectedIndexes = Array.isArray(selection) ? selection : [selection];
      this.elements.answers?.querySelectorAll('.salabom-quiz__answer').forEach((card) => {
        const input = card.querySelector('input');
        const answerIndex = Number(input?.dataset.answerIndex);
        const isSelected = selectedIndexes.includes(answerIndex);
        if (input) input.checked = isSelected;
        card.classList.toggle('is-selected', isSelected);
      });
    }

    renderResult() {
      const profileKey = RESULTS[this.state.profile] ? this.state.profile : 'combined';
      const result = RESULTS[profileKey];
      const product = this.config.recommendedProduct || null;

      this.elements.profileName.textContent = result.title;
      this.elements.profileSummary.textContent = result.summary;
      this.elements.tips.replaceChildren();
      [
        { key: 'relief', title: 'Každodenná úľava' },
        { key: 'wellbeing', title: 'Dlhodobá pohoda a zdravie' },
        { key: 'support', title: 'Kedy a kde hľadať podporu' }
      ].forEach((category) => {
        const section = document.createElement('section');
        section.className = `salabom-quiz__advice-card salabom-quiz__advice-card--${category.key}`;

        const heading = document.createElement('h4');
        heading.className = 'salabom-quiz__advice-heading';
        heading.textContent = category.title;

        const list = document.createElement('ul');
        list.className = 'salabom-quiz__tips';
        (result.advice?.[category.key] || []).forEach((tip) => {
          const item = document.createElement('li');
          item.textContent = tip;
          list.append(item);
        });

        section.append(heading, list);
        this.elements.tips.append(section);
      });
      this.elements.resultLive.textContent = `Tvoj výsledok: ${result.title}`;
      this.renderProduct(product, profileKey);
    }

    renderProduct(product, profileKey) {
      const hasProduct = product && product.title && product.url;
      if (!this.elements.product) return;
      this.elements.product.hidden = !hasProduct;
      if (!hasProduct) return;

      this.elements.productName.textContent = product.title;
      this.elements.productPrice.textContent = product.price || '';
      this.elements.productLink.href = product.url;
      this.elements.productLink.dataset.productHandle = product.handle || '';

      if (product.image) {
        this.elements.productImage.src = product.image;
        this.elements.productImage.alt = product.imageAlt || product.title;
        this.elements.productImage.hidden = false;
        this.elements.productPlaceholder.hidden = true;
      } else {
        this.elements.productImage.hidden = true;
        this.elements.productPlaceholder.hidden = false;
      }

      const canAdd = Boolean(this.config.showAddToCart && product.variantId && product.available);
      this.elements.addToCart.hidden = !canAdd;
      this.elements.addToCart.dataset.variantId = canAdd ? String(product.variantId) : '';
      this.elements.addToCart.dataset.productHandle = product.handle || '';
      this.elements.addToCart.dataset.profile = profileKey;
    }

    async addToCart() {
      const button = this.elements.addToCart;
      const variantId = Number(button?.dataset.variantId);
      if (!button || !variantId || !this.config.cartAddUrl) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = this.config.addingToCartText || 'Pridávam…';

      try {
        const response = await fetch(this.config.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!response.ok) throw new Error(`Cart API: ${response.status}`);
        button.textContent = this.config.addedToCartText || 'Pridané do košíka ✓';
        this.track('quiz_add_to_cart', {
          quiz_profile: this.state.profile,
          product_handle: button.dataset.productHandle || ''
        });
        document.dispatchEvent(new CustomEvent('salabom:cart-updated', { bubbles: true }));
      } catch (error) {
        button.textContent = this.config.cartErrorText || 'Nepodarilo sa pridať';
        console.error('Salabom menopause quiz: produkt sa nepodarilo pridať do košíka.', error);
      } finally {
        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
        }, 2500);
      }
    }

    trackProductClick() {
      this.track('quiz_product_clicked', {
        quiz_profile: this.state.profile,
        product_handle: this.elements.productLink?.dataset.productHandle || ''
      });
    }

    track(eventName, details = {}) {
      const payload = {
        event: eventName,
        quiz_name: this.config.quizName || 'Menopauza: ktorý profil ťa vystihuje?',
        ...details
      };
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', eventName, { content_name: 'quiz' });
      }
    }

    trackLead() {
      if (this.state.leadTracked || typeof window.fbq !== 'function') return;
      window.fbq('track', 'Lead', {
        content_name: 'quiz',
        lead_type: 'email_submitted'
      });
      this.state.leadTracked = true;
    }

    setFormStatus(message, isError) {
      if (!this.elements.formStatus) return;
      this.elements.formStatus.textContent = message;
      this.elements.formStatus.hidden = !message;
      this.elements.formStatus.classList.toggle('is-error', Boolean(isError));
    }

    focusHeading() {
      const active = this.querySelector('[data-screen]:not([hidden]) [data-screen-heading]');
      active?.focus({ preventScroll: false });
    }

    showFatalError() {
      this.querySelectorAll('[data-screen]').forEach((screen) => { screen.hidden = true; });
      const fatal = this.querySelector('[data-screen="fatal"]');
      if (fatal) fatal.hidden = false;
    }
  }

  customElements.define('salabom-menopause-quiz', SalabomMenopauseQuiz);

  // Theme Editor normally triggers connectedCallback when it replaces section DOM.
  // This explicit hook also covers integrations that dispatch shopify:section:load
  // after moving an existing node without reconnecting it.
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target;
    const quizzes = root?.matches?.('salabom-menopause-quiz')
      ? [root]
      : (root?.querySelectorAll?.('salabom-menopause-quiz') || []);
    quizzes.forEach((quiz) => {
      if (quiz.dataset.initialized !== 'true') quiz.connectedCallback();
    });
  });
})();
